export default [{
  icon: "mdi-transit-transfer",
  title: "Product Calls",
  group: "/product-calls",
  children: [
    {
      to: "list",
      title: "List",
      icon: "mdi-format-list-checks",
    },
    {
      title: "Report",
      to: "report",
      icon: "mdi-format-list-checks",
    },
    {
      title: "Grouped Report",
      to: "grouped-report",
      icon: "mdi-format-list-checks",
    },
    {
      title: "Realtime Report",
      to: "realtime-report",
      icon: "mdi-format-list-checks",
    },
  ],
}]
